<template>
  <b-container fluid>
    <admin-breadcrumb :items="[{ text: 'Pricing Plans', path: {name: 'admin-pricing-plans'} }]" name="New Plan" no-title/>
    <admin-panel with-footer sub-title="Pricing Plan Data">
      <admin-pricing-plan-form v-model="formData" :validation="formValidation"/>
      <template v-slot:footer>
        <b-btn
            @click.prevent="submitPricingPlan"
            variant="primary"
            :disabled="formState.processing"
        >
          Submit New Plan
          <b-spinner v-if="formState.processing" class="ml-1" small/>
        </b-btn>
      </template>
    </admin-panel>
  </b-container>
</template>

<script>
import AdminBreadcrumb from "../components/AdminBreadcrumb.vue";
import AdminPanel from "../components/AdminPanel.vue";
import {API_ROUTES} from "../api";
import AdminPricingPlanForm from "../components/AdminPricingPlanForm.vue";

export default {
  name: 'AdminPricingPlanAdd',
  components: {AdminPricingPlanForm, AdminPanel, AdminBreadcrumb},
  data() {
    return {
      formData: {
        type: 'membership',
        name: '',
        company_type: 'metrc',
        rate: 'paid',
        amount: '',
        is_public: true,
        is_hub_access: false,
        hub_addons: [],
        is_rates_by_user: false,
        rates_by_user: [],
        is_rates_by_limit: false,
        rates_by_limit: [],
        is_additional_charges: true,
        additional_charges: {
          order: {
            rate: '%',
            amount: 3
          },
          reorder: {
            rate: '%',
            amount: 1.5
          },
          auction: {
            rate: '%',
            amount: 6
          },
          offer: {
            rate: '%',
            amount: 6
          },
          promoted_auction: {
            rate: '%',
            amount: 1
          },
          fast_auction: {
            rate: '%',
            amount: 1
          },
          reserve_auction: {
            rate: '%',
            amount: 1
          },
          buy_now_auction: {
            rate: '%',
            amount: 1
          }
        },
        billing_frequency: 'one-time',
        billing_recurrence: 'week',
        is_free_trial: false,
        free_trial_length: 1,
        free_trial_period: 'day',
        is_limit_licenses: false,
        licenses_limit: '',
        allow_extra_licenses: false,
        extra_license_price: '',
      },
      formState: {
        processing: false
      },
      formValidation: {}
    }
  },
  methods: {
    submitPricingPlan() {
      this.formState.processing = true;
      this.formValidation = {};
      this.$api.post(API_ROUTES.ADMIN_PRICING_PLANS, this.formData).then(({data}) => {
        this.$bvToast.toast('Pricing plan has been successfully saved', {
          title: 'Success!',
          variant: 'success'
        });
        this.$router.replace({name: 'admin-pricing-plan-view', params: {id: data.pricing_plan.id}});
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to create a new pricing plan', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
